var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.5V0H3V11.5H2Z",
    fill: "#929FAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14648 11.8536L0.146484 9.85359L0.853591 9.14648L2.50004 10.7929L4.14648 9.14648L4.85359 9.85359L2.85359 11.8536C2.65833 12.0489 2.34175 12.0489 2.14648 11.8536Z",
    fill: "#929FAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4H6.5V3H9.5V4Z",
    fill: "#929FAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8H6V7H9.5C9.68939 7 9.86252 7.107 9.94722 7.27639C10.0319 7.44579 10.0136 7.64849 9.9 7.8L7.5 11H10V12H6.5C6.31062 12 6.13749 11.893 6.05279 11.7236C5.96809 11.5542 5.98637 11.3515 6.1 11.2L8.5 8Z",
    fill: "#929FAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44712 0.276393C8.36242 0.107001 8.18932 0 7.99992 0C7.81052 0 7.63742 0.107001 7.55272 0.276393L5.19092 5H6.30892L7.99992 1.61803L9.69092 5H10.8089L8.44712 0.276393Z",
    fill: "#929FAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort-ascending.b7df1a75f8387fcbd51b86bd67d60f65.svg";
export { ForwardRef as ReactComponent };